import { Injectable } from '@angular/core';
import { MatDrawer, MatDrawerToggleResult } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private drawer!: MatDrawer;

  /**
   * Setter for drawer.
   *
   * @param {MatDrawer} drawer
   */
  public setDrawer(drawer: MatDrawer) {
    this.drawer = drawer;
  }

  /**
   * Open this drawer, and return a Promise that will resolve when it's fully opened (or get rejected if it didn't).
   *
   * @returns Promise<MatDrawerToggleResult>
   */
  public open(): Promise<MatDrawerToggleResult> {
    return this.drawer.open();
  }

  /**
   * Close this drawer, and return a Promise that will resolve when it's fully closed (or get rejected if it didn't).
   *
   * @returns Promise<MatDrawerToggleResult>
   */
  public close(): Promise<MatDrawerToggleResult> {
    return this.drawer.close();
  }

  /**
   * Toggle this drawer. This is equivalent to calling open() when it's already opened, or close() when it's closed.
   *
   * @param {boolean} isOpen  Whether the drawer should be open.
   *
   * @returns {Promise<MatDrawerToggleResult>}
   */
  public toggle(isOpen?: boolean): Promise<MatDrawerToggleResult> {
    if (!this.drawer) {
      console.error('Drawer is not initialized. Call setDrawer first.');
      return Promise.reject('Drawer is not initialized.');
    }
    return this.drawer.toggle(isOpen);
  }
}
